var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestDesktopShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 20,
  viewBox: "0 0 18 20",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M16.364 11.455c.9 0 1.636.736 1.636 1.636V18c0 .9-.736 1.636-1.636 1.636H1.636C.736 19.636 0 18.9 0 18v-4.91c0-.9.736-1.635 1.636-1.635s1.637.736 1.637 1.636v3.273h11.454V13.09c0-.9.737-1.636 1.637-1.636M6.398 7.233a1.63 1.63 0 0 1-2.315 0 1.63 1.63 0 0 1-.008-2.308L8.992 0l4.925 4.917a1.64 1.64 0 0 1 .008 2.316 1.63 1.63 0 0 1-2.315 0l-.982-.974v5.056a1.636 1.636 0 1 1-3.273 0V6.267z"
})));
export default SvgPinterestDesktopShare;